/**
 * AAA IDP Form - Photo Guidelines component
 *
 * 
 */
import * as React from 'react';
import Image from '../image/Image';
import { PHOTOS } from '../../data/Data';
import './PhotoGuidelines.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class PhotoGuidelines extends React.Component {
  render() {
    return /*#__PURE__*/_jsxs("div", {
      className: "photo-guidelines-container",
      children: [/*#__PURE__*/_jsx("div", {
        className: "photos-container",
        children: PHOTOS.map((item, index) => {
          return /*#__PURE__*/_jsx(Image, {
            ...item
          }, index);
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "photo-guidelines",
        children: [/*#__PURE__*/_jsx("p", {
          children: "Photo requirements:"
        }), /*#__PURE__*/_jsxs("ul", {
          children: [/*#__PURE__*/_jsxs("li", {
            children: ["A recent", ' ', /*#__PURE__*/_jsx("a", {
              href: "https://www.passports.gov.au/help/passport-photos",
              target: "_blank",
              rel: "noopener noreferrer",
              children: "passport style photo"
            })]
          }), /*#__PURE__*/_jsx("li", {
            children: "Hair cannot cover face"
          }), /*#__PURE__*/_jsx("li", {
            children: "Glasses are not allowed"
          }), /*#__PURE__*/_jsx("li", {
            children: "Plain white background"
          }), /*#__PURE__*/_jsx("li", {
            children: "Clear, good quality image, no watermarks"
          })]
        })]
      })]
    });
  }
}
export default PhotoGuidelines;